import { render, staticRenderFns } from "./UploadOssButton.vue?vue&type=template&id=17865ddb&scoped=true"
import script from "./UploadOssButton.vue?vue&type=script&lang=js"
export * from "./UploadOssButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17865ddb",
  null
  
)

export default component.exports